import GreenDot from '@/assets/icons/green-dot.svg';
import GreyDot from '@/assets/icons/grey-dot.svg';

import { Skeleton } from './skeleton';

interface OpeningStatusProps {
  active: boolean;
}

export function OpeningStatus({ active }: OpeningStatusProps) {
  const icon = active ? GreenDot : GreyDot;

  return <img src={icon} alt="Status" className="h-5 w-5" />;
}

OpeningStatus.Skeleton = function StatusPillSkeleton() {
  return <Skeleton className="h-2 w-2 !rounded-full" />;
};
